export default import.meta.ROLLDOWN_FILE_URL_rUkiH63qcJGEQEedyX41xw